import { ComponentType, ReactNode } from "react";
import { Button, Container, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useHistory } from "@/compat/router";
import CardBase from "../../../components/cards/CardBase";
import { useAuth } from "../../../contexts/authContext";

// The Additional_Opt_Outs__c value that turns the AI features off, carried in the token's opt_outs claim.
const AI_OPT_OUT = "SafetyNest";

export const useAiOptedOut = () => useAuth().hasOptedOutOf(AI_OPT_OUT);

export function AiOptedOutNotice({ backTo }: { backTo: string }) {
    const history = useHistory();

    return (
        <Container>
            <CardBase title="AI isn't available for your organisation">
                <Typography sx={{ mb: 3 }}>
                    Your organisation has opted out of AI features in SafetyNest, so risk assessments can't be built
                    or scanned with AI. You can still create one from a template or upload an existing document.
                </Typography>
                <Button
                    variant="outlined"
                    startIcon={<ArrowBack />}
                    onClick={() => history.push(backTo)}
                >
                    Back
                </Button>
            </CardBase>
        </Container>
    );
}

// Guards the page itself, so a bookmarked or typed URL is refused as well as the chooser.
export default function AiAvailabilityGate({ backTo, children }: { backTo: string; children: ReactNode }) {
    if (useAiOptedOut())
        return <AiOptedOutNotice backTo={backTo} />;

    return <>{children}</>;
}

export const withAiAvailability = <P extends object>(Page: ComponentType<P>, backTo: string) =>
    function AiAvailabilityGuardedPage(props: P) {
        return (
            <AiAvailabilityGate backTo={backTo}>
                <Page {...props} />
            </AiAvailabilityGate>
        );
    };
